// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"e39fb35b","455":"1f8d46ca","977":"b0a4678a"}[chunkId] + ".chunk.js";
};